import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-30c24500")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "基本信息", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("姓名")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("input", { type: "text" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("身份证号")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("民族")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("性别")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("出生日期")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("文化程度")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("家庭人口")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "通信信息", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("手机号")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("微信号")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("所在地区")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("所在乡村")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("详细地址")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "通信信息", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("账户号")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("开户行")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " "),
  /*#__PURE__*/_createTextVNode("银行账号")
], -1)
const _hoisted_21 = { class: "addbtn" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1)
const _hoisted_24 = { class: "btn" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_van_field, {
              name: "uploader",
              label: "头像"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_stcp_h5_uploader, {
                  modelValue: _ctx.headImg,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.headImg = $event)),
                  "after-read": _ctx.imageUploadAfter,
                  onDelete: _ctx.onDeleteImg,
                  "max-count": 1,
                  onPoster: _ctx.onClickImgPoster,
                  class: "upload"
                }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_field, {
              modelValue: _ctx.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
              name: "farmerName",
              placeholder: "请输入姓名",
              type: "text",
              maxlength: 20,
              rules: [{ required: true, message: '请输入姓名' }]
            }, {
              label: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.IDcard,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.IDcard = $event)),
              name: "cardId",
              type: "text",
              placeholder: "请输入身份证号",
              maxlength: 18,
              rules: [{ required: false, message: '请输入身份证号' }]
            }, {
              label: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.nation,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.nation = $event)),
              "is-link": "",
              readonly: "",
              name: "nation",
              label: "民族",
              placeholder: "选择民族",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showNation = true)),
              rules: [{ required: true, message: '选择民族' }]
            }, {
              label: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showNation,
              "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showNation = $event)),
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "民族",
                  "default-index": _ctx.defaultNationIndex,
                  columns: _ctx.nationList,
                  onConfirm: _ctx.onConfirmNation,
                  onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNation = false))
                }, null, 8, ["default-index", "columns", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.sex,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.sex = $event)),
              "is-link": "",
              readonly: "",
              name: "sex",
              label: "性别",
              placeholder: "选择性别",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSex = true)),
              rules: [{ required: true, message: '选择性别' }]
            }, {
              label: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showSex,
              "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSex = $event)),
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "性别",
                  "default-index": _ctx.defaultSexIndex,
                  columns: ['男', '女'],
                  onConfirm: _ctx.onConfirmSex,
                  onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSex = false))
                }, null, 8, ["default-index", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.birth,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.birth = $event)),
              "is-link": "",
              readonly: "",
              name: "birthday",
              label: "出生日期",
              placeholder: "选择出生日期",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showPicker = true)),
              rules: [{ required: true, message: '选择出生日期' }]
            }, {
              label: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showPicker,
              "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => (_ctx.showPicker = $event)),
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_datetime_picker, {
                  modelValue: _ctx.selectInitDate,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectInitDate = $event)),
                  type: "date",
                  title: "选择出生日期",
                  onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showPicker = false)),
                  onConfirm: _ctx.onConfirmInitDate,
                  "min-date": _ctx.minDate,
                  "max-date": _ctx.maxDate
                }, null, 8, ["modelValue", "onConfirm", "min-date", "max-date"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.Culture,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.Culture = $event)),
              "is-link": "",
              readonly: "",
              name: "education",
              label: "文化程度",
              placeholder: "选择文化程度",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showCulture = true)),
              rules: [{ required: true, message: '选择文化程度' }]
            }, {
              label: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showCulture,
              "onUpdate:show": _cache[19] || (_cache[19] = ($event: any) => (_ctx.showCulture = $event)),
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "教育程度",
                  "default-index": _ctx.defaultEducationIndex,
                  columns: _ctx.educationList,
                  onConfirm: _ctx.onConfirmCulture,
                  onCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showCulture = false))
                }, null, 8, ["default-index", "columns", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.family,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.family = $event)),
              name: "population",
              maxlength: 4,
              type: "number",
              placeholder: "请输入家庭人口",
              rules: [{ required: false, message: '请输入家庭人口' }]
            }, {
              label: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_11,
            _createVNode(_component_van_field, {
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.phone = $event)),
              name: "phoneNumber",
              maxlength: 11,
              type: "number",
              placeholder: "请输入手机号",
              rules: [{ required: true, message: '请输入手机号' }]
            }, {
              label: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.wxnumber,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.wxnumber = $event)),
              name: "wxNumber",
              type: "text",
              placeholder: "请输入微信号",
              rules: [{ required: false, message: '请输入微信号' }]
            }, {
              label: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.location,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.location = $event)),
              name: "location",
              placeholder: "请输入所在地区",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showLocation = true)),
              rules: [{ required: true, message: '请输入所在地区' }]
            }, {
              label: _withCtx(() => [
                _hoisted_14
              ]),
              input: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.showMapFn && _ctx.showMapFn(...args)))
                }, _toDisplayString(_ctx.location), 1)
              ]),
              "right-icon": _withCtx(() => [
                _createVNode(_component_van_icon, {
                  onClick: _ctx.showMapFn,
                  name: "location-o"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.rural,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.rural = $event)),
              name: "rural",
              placeholder: "请输入所在乡村",
              rules: [{ required: true, message: '请输入所在乡村' }],
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showRural = true))
            }, {
              input: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.rural), 1)
              ]),
              label: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showRural,
              "onUpdate:show": _cache[29] || (_cache[29] = ($event: any) => (_ctx.showRural = $event)),
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "乡村街道",
                  "default-index": _ctx.defaultStreet1Index,
                  columns: _ctx.ruralList,
                  "columns-field-names": { text: 'street' },
                  onConfirm: _ctx.onConfirmRural,
                  onCancel: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showRural = false))
                }, null, 8, ["default-index", "columns", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showRural2,
              "onUpdate:show": _cache[30] || (_cache[30] = ($event: any) => (_ctx.showRural2 = $event)),
              position: "bottom",
              "close-on-click-overlay": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "乡村街道",
                  "default-index": _ctx.defaultStreet2Index,
                  columns: _ctx.ruralList2,
                  "columns-field-names": { text: 'village' },
                  onConfirm: _ctx.onConfirmRural2,
                  onCancel: _ctx.onCancelRural2
                }, null, 8, ["default-index", "columns", "onConfirm", "onCancel"])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.detailLocation,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.detailLocation = $event)),
              name: "addressInfo",
              rows: "1",
              autosize: "",
              label: "详细地址",
              type: "textarea",
              placeholder: "请输入详细地址"
            }, {
              label: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_17,
            _createVNode(_component_van_field, {
              modelValue: _ctx.zhNumber,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.zhNumber = $event)),
              name: "account",
              placeholder: "请输入",
              maxlength: 20,
              rules: [{ required: false, message: '请输入' }]
            }, {
              label: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.khh,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.khh = $event)),
              name: "bankName",
              placeholder: "请输入",
              maxlength: 20,
              rules: [{ required: false, message: '请输入' }]
            }, {
              label: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.bankNumber,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.bankNumber = $event)),
              name: "bankNumber",
              placeholder: "请输入",
              maxlength: 30,
              type: "number",
              rules: [{ required: false, message: '请输入' }]
            }, {
              label: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_button, {
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createElementVNode("div", {
      class: "mapbox",
      style: _normalizeStyle({ zIndex: _ctx.showMap ? 2 : -1 ,opacity:_ctx.showMap ? 1 : 0})
    }, [
      _hoisted_23,
      _withDirectives(_createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, "取消"),
        _createElementVNode("button", {
          onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.allright && _ctx.allright(...args)))
        }, "确定")
      ], 512), [
        [_vShow, _ctx.showMap]
      ])
    ], 4)
  ]))
}